import { ISchedule } from '@gettactic/api';
import { sortSchedulesByStart } from '@gettactic/helpers/src/schedules/sortSchedulesByStart';
import React from 'react';
export function useSortedSchedules(
  data: ISchedule[] | undefined | null,

  filter: 'rooms' | 'workspaces' | 'all' = 'all'
) {
  return React.useMemo(() => {
    const noFilter: ISchedule[] = data ?? [];
    return noFilter
      .filter((x) =>
        filter === 'all'
          ? true
          : (filter === 'rooms' && x.resource.type === 'meeting_room') ||
            (filter === 'workspaces' && x.resource.type !== 'meeting_room')
      )
      .sort(sortSchedulesByStart);
  }, [filter, data]);
}
